<template>
  <section class="download">
    <form @submit.prevent="handleDownload">
      <f-card>
        <template>
          <div class="main flex flex-space">
            <div class="label-group">
              <span class="label">Type</span>
              <f-select
                placeholder="Choisir une option"
                trackBy="value"
                label="label"
                :showLabels="false"
                :options="options"
                :searchable="false"
                v-model="type">
              </f-select>
            </div>
            <div class="label-group flex flex-space">
              <span class="label">Date</span>
              <datepicker
                id="start"
                ref="start"
                v-model="start"
                :monday-first="true"
                format="dd/MM/yyyy"
                placeholder="JJ/MM/AAAA"
                :language="fr"
                :disabled-dates="computedDisabledDateFrom"
                class="f-datepicker">
                <span slot="afterDateInput" class="bar"></span>
              </datepicker>
              au
              <datepicker
                id="end"
                ref="end"
                v-model="end"
                :monday-first="true"
                format="dd/MM/yyyy"
                placeholder="JJ/MM/AAAA"
                :language="fr"
                :disabled-dates="computedDisabledDateTo"
                class="f-datepicker">
                <span slot="afterDateInput" class="bar"></span>
              </datepicker>
            </div>
          </div>
        </template>

        <template slot="footer">
          <div class="footer flex flex-right">
            <ab-button class="primary" @click="showModal">Générer</ab-button>
          </div>
        </template>
      </f-card>
    </form>

    <f-modal class="modal" name="download" height="auto">
      <section>
        <f-card>
          <main>
            <p>Le fichier est prêt à être téléchargé.</p>
          </main>
          <footer class="flex flex-right">
            <a class="btn-action primary"
              :href="href"
              target="_blank"
              :download="download"
              @click="$modal.hide('download')">Télécharger</a>
          </footer>
        </f-card>
      </section>
    </f-modal>
  </section>
</template>

<script>
  import AbButton from '@/components/form/button/ab-button.vue';
  import CSelect from '@/components/form/select/c-select.vue';
  import FCard from '@/components/layout/card/f-card.vue';
  import Datepicker from 'vuejs-datepicker';
  import { fr } from 'vuejs-datepicker/dist/locale';
  import { mapState } from 'vuex';
  import messages from '../messages/messages.js';
    import clientEdit from '@/components/mixins/clientCalendar.js';

  export default {
    name: "Download",
    mixins: [ clientEdit ],
    components: {
      AbButton,
      CSelect,
      FCard,
      Datepicker,
    },
    data() {
      return {
        options: [
          {
            value: 'livraison_ca',
            label: "Bons de livraison et factures"
          },
          {
            value: 'couverts_ca',
            label: "Nombre de couverts et chiffre d'affaires"
          },

        ],
        type: "",
        start: '',
        end: '',
        fileData: '',
        fr: fr,
        href: '#',
        download: '',
      }
    },
    computed: {
      ...mapState({ clientId: function(state) { return state.client } }),
    },
    methods: {
      async handleDownload() {
        const startEl = this.$el.querySelector('#start');
        const endEl = this.$el.querySelector('#end');
        startEl.classList.remove('error');
        endEl.classList.remove('error');

        if (this.start && this.end) {
          let data = '';
          const start = this.start.getTime();
          const end = this.end.getTime();

          if (start > end) {
            startEl.classList.add('error');
            endEl.classList.add('error');
            this.displayToast({ message: messages.selectors.Download.custom.inversedMonths, mode: 'error' });
            return;
          }

          if (this.clientId) {
            if (this.type.value == "livraison_ca") {
              data = await this.$store.dispatch('exportDeliveryform', {
                clientId: this.clientId,
                start: this.start.getTime(),
                end: this.end.getTime(),
              });
            }
            else if (this.type.value == "couverts_ca") {
              data = await this.$store.dispatch('exportSalefigure', {
                clientId: this.clientId,
                start: this.start.getTime(),
                end: this.end.getTime(),
              });
            }
            if (data) {
              this.fileData = data;
              this.showModal();
            }
          }
        } else {
          this.displayToast({ message: messages.selectors.Download.custom.inputMonth, mode: 'error' });
        }
      },
      showModal() {
        const from = this.formatDate(this.start)
        const to = this.formatDate(this.end);
        this.href ='data:attachment/csv;charset=utf-8,' + encodeURIComponent(this.fileData);
        this.download =`${this.type.value}_${from}-${to}.csv`;

        this.$modal.show('download', {});
      },
      /**
       * @see https://stackoverflow.com/questions/23593052/format-javascript-date-to-yyyy-mm-dd
       */
      formatDate(d) {
        let month = `${d.getMonth() + 1}`;
        let day = `${d.getDate()}`;
        let year = `${d.getFullYear()}`;
        if (month.length < 2) month = `0${month}`;
        if (day.length < 2) day = `0${day}`;
        return [ day, month, year ].join('-');
      }
    },
  }
</script>

<style scoped>
  /* Main */
  .main {
    margin-bottom : 1rem;
  }
  .label-group {
    min-width: 40%;
  }
  .label-group .label {
    font-size: 15px;
    font-weight: 600;
    margin-right: 1rem;
  }
  .label-group .c-select {
    width: 25rem;
  }
</style>
<style>
  /* Place calendar */
  .vdp-datepicker__calendar { right: 0; }
</style>
<style src="@/assets/styles/datepickers.css"></style>